import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DataBagService } from 'src/app/common/data-bag.service';
import { TourismEventsOrganizationDialogComponent } from './tourism-events-organization-dialog/tourism-events-organization-dialog.component';
import { MatCardModule } from '@angular/material/card';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { NgIf } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
	selector: 'app-tourism-events-organization',
	templateUrl: './tourism-events-organization.component.html',
	styleUrls: ['./tourism-events-organization.component.scss'],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [MatCardModule, MatMenuModule, RouterModule, NgIf, MatButtonModule],
})
export class TourismEventsOrganizationComponent implements OnChanges {
	@Input() client: any;
	@Output() clientData = new EventEmitter();
	protected clientObject: any = null;

	constructor(
		private readonly bag: DataBagService,
		public dialog: MatDialog,
	) {}

	ngOnChanges(client): void {
		if (!client) {
			return;
		}
		this.clientObject = this.client;
	}

	changeClient() {
		const dialogRef = this.dialog?.open(TourismEventsOrganizationDialogComponent);
		const sub = dialogRef.componentInstance.clientChanged.subscribe((obj) => {
			if (obj.company) this.selectOrganization(obj.id);
			if (!obj.company) this.selectUser(obj.id);
		});
		dialogRef.afterClosed().subscribe((result) => {
			return sub.unsubscribe();
		});
	}

	selectOrganization(organization) {
		this.bag.get(`/organization/${organization.id}/`, (result, error) => {
			this.client = result;
			this.clientData.emit({ id: this.client.id, company: true });
		});
	}

	selectUser(user) {
		this.bag.get(`/profile/data_full/${user.id}/`, (result, error) => {
			this.client = result;
			this.clientData.emit({ id: this.client.id, company: false });
		});
	}
}
